'use strict';

/* jshint -W098 */
angular.module('mean.invoices').controller('InvoicesController', ['$scope', 'Global', 'Invoices', 'MeanUser', 'Users', '$filter', 'toaster', 'printInvoiceService',
  function($scope, Global, Invoices, MeanUser, Users, $filter, toaster, printInvoiceService) {
    $scope.global = Global;
    $scope.package = {
      name: 'system-lots'
    };

    $scope.user = MeanUser.user;
    $scope.billedTotal = 0;
    $scope.paidTotal = 0;

    $scope.init = function() {
        Invoices.query({}, function(invoices) {
            $scope.invoices = invoices;

            $scope.computeTotals();
        });
    };

    $scope.computeTotals = function() {
        $scope.billedTotal = 0;
        $scope.paidTotal = 0;
        var billed = $filter('filter')($scope.invoices, {'billed': true, 'paid': false}, true);
        _.each(billed, function(bill) {
            $scope.billedTotal += bill.total;
        });

        var paid = $filter('filter')($scope.invoices, {'paid': true}, true);
        _.each(paid, function(pay) {
            $scope.paidTotal += pay.total;
        });
    }

    $scope.dateRangeUpdated = function() {

    };

    $scope.printInvoice = function(inv) {
        console.log(inv);
        printInvoiceService.print(inv, true);
    };

    $scope.emailInvoice = function(inv) {
        printInvoiceService.print(inv, false);
        inv.billed = true;
        $scope.updateBilled(inv);
    };

    $scope.updateBilled = function(inv) {
        console.log(inv);
        inv.$update(function(success) {
            inv = success;
            $scope.computeTotals();
            toaster.pop('success', 'Invoice Billed');
        }, function(error) {
            toaster.pop('error', 'Invoice Bill Error', error);
        });
    };

    $scope.updatePaid = function(inv) {
        console.log(inv);
        inv.$update(function(success) {
            inv = success;
            $scope.computeTotals();
            toaster.pop('success', 'Invoice Paid');
        }, function(error) {
            toaster.pop('error', 'Invoice Pay Error', error);
        });
    };

  }
]);


// WEBPACK FOOTER //
// ./packages/custom/invoices/public/controllers/invoices.js